import { useState, lazy, Suspense } from "react";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { Routes, Route, Navigate } from "react-router-dom";
import { CssBaseline, ThemeProvider, Box, useTheme } from "@mui/material";
import { ColorModeContext, useMode, tokens } from "./theme";
import { useAuthState } from "react-firebase-hooks/auth";

import { auth } from "./firebase";
import Topbar from "./screens/global/Topbar";
import Sidebar from "./screens/global/Sidebar";
import Register from "./screens/register";
import Logout from "./screens/logout";
import Copyright from "./components/Copyright";
const Invites = lazy(() => import("./screens/invites"));
const Users = lazy(() => import("./screens/users"));
const Login = lazy(() => import("./screens/login"));
const UserView = lazy(() => import("./screens/users/userView"));

export const ProtectedRoute = ({ children }) => {
  const [user] = useAuthState(auth);
  if (!user) {
    return <Navigate to="/login" />;
  }
  return children;
};

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);

  const [user, loading] = useAuthState(auth);
  const themeInstance = useTheme();
  const colors = tokens(themeInstance.palette.mode);

  if (user == null && loading) {
    return null;
  }

  // console.log({
  //   env: process.env.NODE_ENV,
  //   api: process.env.REACT_APP_GOOGLE_API_KEY,
  //   version: process.env.REACT_APP_VERSION,
  // });

  return (
    <ColorModeContext.Provider value={colorMode}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Box display="flex" flexDirection="column" minHeight="100vh">
            <Box display="flex" flex="1">
              <Sidebar isSidebar={isSidebar} />
              <Box component="main" flex="1" display="flex" flexDirection="column">
                <Topbar setIsSidebar={setIsSidebar} />
                <Box flex="1">
                  <Suspense fallback={<h1>Loading...</h1>}>
                    <Routes>
                      <Route path="/login" element={<Login />} />
                      <Route path="/register" element={<Register />} />
                      <Route
                        path="/invites"
                        element={
                          <ProtectedRoute>
                            <Invites />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/logout"
                        element={
                          <ProtectedRoute>
                            <Logout />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/"
                        element={
                          <ProtectedRoute>
                            <Users />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/users"
                        element={
                          <ProtectedRoute>
                            <Users />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/userView/:id"
                        element={
                          <ProtectedRoute>
                            <UserView />
                          </ProtectedRoute>
                        }
                      />
                    </Routes>
                  </Suspense>
                </Box>
              </Box>
            </Box>
            <Copyright sx={{ backgroundColor: `${colors.primary[600]} !important`, color: "white", padding: 1}} />
          </Box>
        </ThemeProvider>
      </LocalizationProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
